import { IonCard, IonCardContent, IonInput, IonLabel, IonLoading, IonToast } from '@ionic/react'
import './update-pw.scss'
import BasePage from 'pages/base-page/base-page.page'
import { useTranslation } from 'react-i18next'

import { useFormik } from 'formik'
import * as Yup from 'yup'
import { useContext, useState } from 'react'
import { profileService, routeService } from 'services'
import { Redirect } from 'react-router'
import { BaseButton } from 'components'
import { authContext } from 'contexts'
import i18next from 'i18n'

const validationSchema = Yup.object().shape({
  oldpw: Yup.string().required(i18next.t('form_validator.required')),
  newpw: Yup.string()
    .required(i18next.t('form_validator.required'))
    .min(8, i18next.t('form_validator.short_pw'))
    .max(16, i18next.t('form_validator.long_pw'))
    .matches(/[A-Z]+/, i18next.t('form_validator.uppercase_pw'))
    .matches(/[a-z]+/, i18next.t('form_validator.lowercase_pw'))
    .matches(/[0-9]+/, i18next.t('form_validator.number_pw'))
    .matches(/[\!\?\*\.]+/, i18next.t('form_validator.special_character_pw'))
    .test('password-match', i18next.t('form_validator.match_pw'), function (value) {
      return value === this.parent.confirmpw
    }),
  confirmpw: Yup.string()
    .oneOf([Yup.ref('newpw'), ''], i18next.t('form_validator.match_pw'))
    .required(i18next.t('form_validator.required')),
})

const UpdatePw: React.FC = () => {
  const auth = useContext(authContext)
  const [loading, setLoading] = useState(false)
  const [redirect, setRedirect] = useState<string | undefined>(undefined)
  const [isOpen, setIsOpen] = useState(false)
  const [color, setColor] = useState('')
  const [message, setMessage] = useState('')

  const { t } = useTranslation()

  const formik = useFormik({
    initialValues: {
      oldpw: '',
      newpw: '',
      confirmpw: '',
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      setLoading(true)
      profileService.changePassword(
        values.oldpw,
        values.newpw,
        auth?.changeToken,
        () => {
          !auth?.user && auth?.removeTokens()
          setLoading(false)
          setColor('success')
          setMessage(t('pw_success'))
          setIsOpen(true)
          !auth?.user && setRedirect(routeService.generateRoutePath('/login'))
        },
        (res: any) => {
          setLoading(false)
          if (res.response.status === 404) {
            setColor('danger')
            setMessage(t('password_not_valid'))
            setIsOpen(true)
          } else {
            !auth?.user && auth?.removeTokens()
            setRedirect(routeService.generateRoutePath('/error'))
          }
        },
      )
    },
  })

  if (!!redirect) {
    return <Redirect to={redirect}></Redirect>
  }

  return (
    <BasePage pageClass="edisu-page-update_pw" bgColor="#EDF2F5">
      <IonLoading isOpen={loading} message={t('loading')} />
      <IonToast isOpen={isOpen} color={color} onDidDismiss={() => setIsOpen(false)} message={message} duration={5000}></IonToast>
      <div className="edisu-update_pw-grid">
        <h2> {t('update_pw_title')}</h2>
        <IonCard className="card">
          <IonCardContent>
            <form onSubmit={formik.handleSubmit} className="container">
              <div className="field">
                <IonLabel className="form-label">{t('oldpw')}</IonLabel>
                <IonInput
                  value={formik.values.oldpw}
                  onIonInput={formik.handleChange}
                  onBlur={formik.handleBlur}
                  className="input"
                  placeholder=""
                  name="oldpw"
                ></IonInput>
                <IonLabel className={formik.touched.oldpw && formik.errors.oldpw ? 'form-label-error' : 'hidden'}>
                  {formik.touched.oldpw && formik.errors.oldpw ? formik.errors.oldpw : t('oldpw')}
                </IonLabel>
              </div>
              <div className="field">
                <IonLabel className={'form-label'}>{t('newpw')}</IonLabel>
                <IonInput
                  value={formik.values.newpw}
                  onIonInput={formik.handleChange}
                  onBlur={formik.handleBlur}
                  className="input"
                  placeholder=""
                  name="newpw"
                ></IonInput>
                <IonLabel className={formik.touched.newpw && formik.errors.newpw ? 'form-label-error' : 'hidden'}>
                  {formik.touched.newpw && formik.errors.newpw ? formik.errors.newpw : t('newpw')}
                </IonLabel>
              </div>
              <div className="field">
                <IonLabel className={'form-label'}>{t('confirmpw')}</IonLabel>
                <IonInput
                  value={formik.values.confirmpw}
                  onIonInput={formik.handleChange}
                  onBlur={formik.handleBlur}
                  className="input"
                  placeholder=""
                  name="confirmpw"
                ></IonInput>
                <IonLabel className={formik.touched.confirmpw && formik.errors.confirmpw ? 'form-label-error' : 'hidden'}>
                  {formik.touched.confirmpw && formik.errors.confirmpw ? formik.errors.confirmpw : t('confirmpw')}
                </IonLabel>
              </div>

              <div className="buttonUpdate">
                <BaseButton type="submit" label={t('update')}></BaseButton>
              </div>
            </form>
          </IonCardContent>
        </IonCard>
      </div>
    </BasePage>
  )
}

export default UpdatePw
